import { ISettingEntry } from "@faire/web-api--source/indigofair/settings/ISettingEntry";

import { IFrontendSetting } from "./IFrontendSetting";
import {
  DatedFrontendSettingName,
  ISettingSchema,
  SettingValue,
} from "./ISettingSchema";
import { setting } from "./setting";

type ExperimentSchema<
  T extends SettingValue,
  S extends DatedFrontendSettingName,
  C extends keyof typeof ISettingEntry.SerializeToClient,
> = Omit<ISettingSchema<T, S, C>, "type"> & {
  /**
   * yyyy-MM-dd string for when to notify the owner about doing a cleanup.
   * Required for experiment settings.
   */
  notifyAfter: string;
};

export function experiment<
  T extends SettingValue,
  S extends DatedFrontendSettingName,
  C extends keyof typeof ISettingEntry.SerializeToClient,
>(schema: ExperimentSchema<T, S, C>): IFrontendSetting<T, S, C> {
  return setting({
    type: ISettingEntry.SettingType.EXPERIMENT,
    testable: true,
    ...schema,
  });
}
